"use client";

import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useState } from "react";
import { Icon } from "@iconify/react";
import PropTypes from "prop-types";

import SocketContext from "@/socket/Context";
import Modal from "@/components/shared/modal";
import styles from "./styles.module.scss";
import services from "@/store/services";
import Components from "@/components";
import utils from "@/utils";

function EnrollUnEnrollBtn(props) {
  const { courseInfo, videoInfo, isEnrolled } = useSelector(
    (state) => state.video
  );
  const { premiumCourseEnrollModal } = useSelector((state) => state.modal);
  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const enrollments = useSelector((state) => state?.enrollment);
  const user = useSelector((state) => state?.user?.users);
  const { socket } = useContext(SocketContext).SocketState;

  const dispatch = useDispatch();

  const handleUnenrollment = async () => {
    //UnEnrollment...
    dispatch(services.unEnrollUser(courseInfo?._id, user._id, socket));
    props.warningCallback({ show: false });
  };

  const handleEnrollment = async () => {
    if (user?.email) {
      const isEnrolled = enrollments?.find(
        (course) => course.courseId === courseInfo?._id
      );

      if (!isEnrolled) {
        if (courseInfo?.visibility === "restricted") {
          dispatch(services.tooglePremiumCourseModal());
        } else {
          setShowEnrollModal(true);
        }
      } else {
        props.warningCallback({
          show: true,
          type: "unenroll",
          name: "This Course",
          btnClick: handleUnenrollment,
        });
      }
    } else {
      dispatch(services.toggleSigninModal());
    }
  };

  return (
    <>
      <Modal
        placement="top"
        showModal={premiumCourseEnrollModal}
        className={"passwordModal"}
        heading={"🚀 Unlock Premium Learning!"}
        setShowModal={() => dispatch(services.tooglePremiumCourseModal())}
      >
        <Components.PremiumCourseEnrollWarn />
      </Modal>

      <Components.Modal
        showModal={showEnrollModal}
        setShowModal={setShowEnrollModal}
        heading={" "}
      >
        <Components.EnrollModal
          onConfirm={() => {
            dispatch(services.enrollUser(courseInfo?._id, user._id, socket));
            dispatch(services.startPostEnrollTour());
            setShowEnrollModal(false);
          }}
        />
      </Components.Modal>
      {courseInfo?.ctfTitle ? (
        <button
          id="vd-enroll-btn"
          className={`${styles["vd-enroll-btn"]} ${
            isEnrolled ? styles["enrolled"] : ""
          } ${props.className} video-enroll-btn`}
          disabled={user._id === videoInfo?.creatorInfo[0]?._id}
          onClick={handleEnrollment}
        >
          {isEnrolled && <Icon icon={"mingcute:certificate-fill"} />}
          {isEnrolled ? "Enrolled" : "Enroll Now"}
        </button>
      ) : null}
    </>
  );
}

EnrollUnEnrollBtn.propTypes = {
  warningCallback: PropTypes.func.isRequired,
  isListItem: PropTypes.oneOfType([
    PropTypes.bool, // Optional string
    PropTypes.oneOf([undefined]), // Optional undefined
  ]),
  className: PropTypes.string,
};

export default EnrollUnEnrollBtn;
